/*************************************
 *
 * 路由管理
 *
 * 模块化管理 路由
 *
 *************************************/

import Vue from 'vue'
import Router from 'vue-router'
import groupBuy from './modules/groupBuy'
import shoppingMall from './modules/shoppingMall'
import live from './modules/live'
import storeSale from './modules/storeSale'
import appointment from './modules/appointment'
import publicRoute from './modules/public'
import center from './modules/center'

Vue.use(Router)

let routes = new Set([...groupBuy, ...shoppingMall, ...live, ...storeSale, ...appointment, ...publicRoute, ...center])

export default new Router({
  base: '/',
  mode: 'history',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js